import { render } from "./CompanyAlignmentCard.vue?vue&type=template&id=085de769"
import script from "./CompanyAlignmentCard.vue?vue&type=script&lang=js"
export * from "./CompanyAlignmentCard.vue?vue&type=script&lang=js"

import "./CompanyAlignmentCard.vue?vue&type=style&index=0&id=085de769&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__